module.exports = __webpack_public_path__ + "img/salon.5b518861.jpeg";